module.exports = __webpack_public_path__ + "static/media/vlreality.020d6082.pdf";